import React, { Component } from 'react';
import ReactDOM from 'react-dom';
//import { Animate, AnimateKeyframes, AnimateGroup } from 'react-simple-animate';

export default class JobFullDetailsInvoice extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      invoice_data: props.invoice_data || null,
      data: props.data || null,
      isLoadingInvoiceInfo: true,
      original: {
        invoice_number: props.data.invoice_number
      },
      invoice_numbers:null,
      changeInvoiceNumberApiUrl: "/api/v1/portal/jobs/change-invoice-number/",
      changeSInvoiceNumberApiUrl: "/api/v1/portal/jobs/change-subcontract-invoice-number/",
    };

    this.handleJobInvoiceNumberChange = this.handleJobInvoiceNumberChange.bind(this);

      
      
    this.handleInvoiceJobActualNoteChange = this.handleInvoiceJobActualNoteChange.bind(this);
  }

  componentDidMount() {
    this.getInvoiceInfo();
    Echo.channel(
      'jobs-table-'+this.state.data.id
    ).
    listen(
      'InvoiceInfoChanged',
      (e) => {
        this.getInvoiceInfo();
      }
    );
  }
  handleJobInvoiceNumberChange(e) {
    let newJobInvoiceNumber = e.target.value;
    let data = {...this.state.data};
    data.invoice_number = newJobInvoiceNumber;
    this.setState({data});
  }
  handleInvoiceJobActualNoteChange(e){
    let newInvoiceActualNote = e.target.value;
    let data = {...this.state.data};
    data.invoice_job_actual_note = newInvoiceActualNote;
    this.setState({data});
  }
  getInvoiceInfo() {
    let url = '/api/v1/portal/invoice-info/job/'+this.state.data.id;
    return fetch(url, {
      method: "GET",
      mode: "cors",
      cache: "no-cache",
      credentials: "same-origin",
      headers: {
        "Authorization": 'Bearer '+window.api_token,
        "Accept": 'application/json'
      },
    }).
    then((responseText) => {
      let response = responseText.json();
      response.then((invoiceInfoJson) => {
        this.setState({
          invoice_data: invoiceInfoJson['invoice_data'],
          isLoadingInvoiceInfo: false,
          invoice_numbers:invoiceInfoJson['invoiced_numbers'],
        })
      });
    });
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      data: nextProps.data
    });
  }


  changeInvoiceNumber(e) {
    let newInvoiceNumber = e.target.value;
    let changeInvoiceNumber = confirm(
      'change InvoiceNumber to '+ newInvoiceNumber + '?'
    );
    if (newInvoiceNumber === this.state.original.invoice_number) {
      return null;
    }

    if (changeInvoiceNumber) {
      let jobId = this.state.data.id;
      return fetch(
        this.state.changeInvoiceNumberApiUrl + this.state.data.id,
        {
          method: "POST",
          mode: "cors",
          cache: "no-cache",
          credentials: "same-origin",
          headers: {
            "Authorization": 'Bearer ' + window.api_token
            , "Accept": 'application/json'
          },
          body: JSON.stringify(
            {
              invoice_number: this.state.data.invoice_number
            }
          )
        }
      ).then((responseText) => {
        let response = responseText.json();
        response.then((response) => {
          // alert(response);
        });
      });
    }
    else {
      $(
        "#jobs-table-row-" +
        this.state.data.id +
        " input[name=invoice_number]"
      ).val(
        e.target.value
      );
    }
  }
  changeInvoiceJobActualNote(e){
    let newInvoiceActualNote = e.target.value;
    let changeInvoiceActualNote = confirm(
      'Want to save Invoice Note ?'
    );

    if (changeInvoiceActualNote) {
      $.ajax({
        url: "/api/v1/portal/jobs/change-invoice-job-actual-note/"+this.state.data.id,
        data: {
          api_token: window.api_token,
          invoice_job_actual_note: newInvoiceActualNote
        },
        cache: false,
        method: 'post',
      })
        .done(function(res) {
          $('#infomodallabel').html('Invoice Note');
          $('#infomodal .modal-body').html(res);
          $('#infomodal').modal();
        });
    }
    else {
      $("#jobs-table-row-"+this.state.data.id+" textarea[name=invoice_job_actual_note]").val(e.target.value);
    }
  }
  handleDownloadAppraisalsAndExpensesForSelectedJobsButtonClick(e, i) {
    this.getZipDownloadForJobs(i);
  }
  getZipDownloadForJobs(jobIncludeInZip) {

    this.setState({
      selectedJobsZipping: true
    });

    return fetch(
      '/api/v1/portal/appraisal-expense-invoice-info/job/'
      +jobIncludeInZip+'/combined-appraisal-expense-zip-download',
      {
        method: "POST",
        mode: "cors",
        cache: "no-cache",
        credentials: "same-origin",
        headers: {
          "Authorization": 'Bearer ' + window.api_token,
          "Accept": 'application/json'
        },
        body: JSON.stringify({
          jobsToIncludeInZip: jobIncludeInZip
        }),
      }
    ).then(
      (responseText) => {
        let response = responseText.json();
        response.then((customerJobZip) => {
          if (customerJobZip.zip) {
            this.downloadZIP(customerJobZip.zip);
          }
        });
      }
    );
  }
  downloadZIP(zipFile) {
    this.setState({
      selectedJobsZipping: false
    });
    window.location = zipFile;
  }

  enterPressed(event) {
    let code = event.keyCode || event.which;
    if (code === 13) { // [ Enter ]
      $(event.target).trigger('blur');
    }
  }
  render() {
    let invoiceInfoBlock;
    let InvoiceLines = [];
    let InvoiceNumbers = [];
    invoiceInfoBlock = (
      <p><strong>No invoice available.</strong></p>
    );
    
    let invoiceRow = 0;
    if (this.state.invoice_data && (this.state.invoice_data.length > 0)) {
      if(this.state.invoice_numbers && (this.state.invoice_numbers.length > 0)){
        this.state.invoice_numbers.forEach(function(num) {
          InvoiceNumbers.push(
            <tr key={num.id}>
              <td><a href={"/jobs/view/"+num.id} target="_blank">{num.id}</a></td>
              <td>{num.invoice_number}</td>
            </tr>
          );
        });
      }
      let jobId = this.state.data.id;
      this.state.invoice_data.forEach(function(i) {
        invoiceRow++;
        InvoiceLines.push(
          <div className="row" key={'job-'+jobId+'-invoice-row-'+invoiceRow}>
            <div className="col-md-1">{i.ACCOUNT_REF}</div>
            <div className="col-md-1">{i.NOMINAL_CODE}</div>
            <div className="col-md-1">{i.QTY_ORDER}</div>
            <div className="col-md-1">{i.NET_AMOUNT}</div>
            <div className="col-md-1">{i.SERVICE_AMOUNT}</div>
            <div className="col-md-4">{i.SERVICE_TEXT}</div>
            <div className="col-md-1">{i.TAX_AMOUNT}</div>
            <div className="col-md-1">{i.TAX_CODE}</div>
            <div className="col-md-1">{i.INVOICE_TYPE}</div>
          </div>
        )
      });

      invoiceInfoBlock = (
        <div className="jobs-table-invoice-container"
             key={'job-'+jobId+'-invoice'}>

          <div className="row jobs-table-invoice-number-input-container">
            <div className="col-md-6 no-border">
              
                <label>Invoice Number:</label>
                <input
                  type="text"
                  className="jobs-table-editable form-control form-control-lg"
                  value={this.state.data.invoice_number}
                  onChange={this.handleJobInvoiceNumberChange}
                  onBlur={(e) => this.changeInvoiceNumber(e)}
                  onKeyUp={this.enterPressed.bind(this)}
                  placeholder="invoice #" 
                  name="invoice_number" />
              
            </div>
            <div className="col-md-6  no-border">
            <label>Invoice Note:</label>
                <textarea 
                  placeholder="Enter invoice notes" 
                  className="job-invoice-tab-custom-note-box" 
                  value={this.state.data.invoice_job_actual_note||''}
                  onChange={this.handleInvoiceJobActualNoteChange}
                  onBlur={(e) => this.changeInvoiceJobActualNote(e)}
                  name="invoice_job_actual_note"/>
            </div>
          </div>
          <div className="row">
          { (this.state.invoice_numbers && (this.state.invoice_numbers.length > 0)) ? 
                <div className="col-md-3 no-border">
                  <label>Parent/Child jobs with invoice numbers:</label>
                    <table className="table table-bordered">
                    <thead>
                      <tr>
                        <th>Job</th>
                        <th>Invoice Number.</th>
                      </tr>
                    </thead>
                    <tbody>
                    {InvoiceNumbers} 
                    </tbody>
                    </table>
                    <br/>
                </div>
                :'' }
          </div>
          <div className="row">
            <div className="col-md-1">Account Ref</div>
            <div className="col-md-1">Nominal Code</div>
            <div className="col-md-1">Qty Order</div>
            <div className="col-md-1">Net Amount</div>
            <div className="col-md-1">Total Price</div>
            <div className="col-md-4">Service Text</div>
            <div className="col-md-1">Tax Amount</div>
            <div className="col-md-1">Tax Code</div>
            <div className="col-md-1">Invoice Type</div>
          </div>
          {InvoiceLines}
          <br />
          <br />
          <a className="btn btn-lg btn-success pull-right"
             href={"/api/v1/portal/invoice-info/job/"+jobId+
             '/csv?api_token='+window.api_token}
             target="_blank"
          >
            <i className="fa fa-download"></i> Download Sage CSV
          </a>
          <button
            className="btn btn-lg btn-outline-success customer-invoicing-combined-assets-download"
            onClick={(e) => {
             e.preventDefault();
             this.handleDownloadAppraisalsAndExpensesForSelectedJobsButtonClick(
               e, jobId
             );
            }}
            disabled={this.state.selectedJobsZipping === true}
          >
          <i className="fa fa-download"></i>&nbsp;
          <i className="fa fa-file-archive"></i>&nbsp;
          Download Appraisals and Expenses for all selected jobs into ZIP
            &nbsp;&nbsp;
            {
              (this.state.selectedJobsZipping === true) ?
                <i className="fas fa-cog fa-spin"></i>
                :
                ''
            }

          </button>
        </div>
      );
    }
    return (
      this.state.isLoadingInvoiceInfo ?
      (<div className="loading-box">
                      <span className="add-loading-text">
                      <i className="fa fa-spinner fa-pulse"></i>
                      </span></div>) :
      invoiceInfoBlock
    );
  }
}